/* STEP: Done — success summary + links back to directory / 360. */
import React from 'react'
import PropTypes from 'prop-types'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined'

export default function StepDone({W, navigate}) {
  const nm = (W.parentMode === 'new' ? W.A.name : W.D.parentId) || W.D.display || 'Account'
  const partnerId = W.committedParentId
  return (
    <div className='card card-pad' style={{maxWidth: 560, margin: '0 auto', textAlign: 'center'}}>
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: 'var(--success-bg)',
          color: 'var(--success)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '6px auto 14px',
        }}
      >
        <CheckCircleOutlinedIcon style={{width: 34, height: 34}} />
      </div>
      <h2 style={{margin: '0 0 6px'}}>Account code created</h2>
      <p className='muted' style={{fontSize: 13}}>
        {W.D.code || ''} under <b>{nm}</b> has been set up
        {W.parentMode === 'new' ? ' along with the new parent' : ''} and now appears in the directory.
      </p>
      <div style={{marginTop: 18, display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap'}}>
        <button type='button' className='btn btn-primary' onClick={() => navigate('/supply/partners')}>
          Open Directory
        </button>
        {partnerId ? (
          <button type='button' className='btn' onClick={() => navigate('/supply/partners/' + partnerId)}>
            View Partner 360
          </button>
        ) : null}
        <button type='button' className='btn btn-ghost' onClick={() => navigate(0)}>
          Add another code
        </button>
      </div>
    </div>
  )
}

StepDone.propTypes = {
  W: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
}
